import { createContext } from 'react'
import styles from './styles-context.module.scss'
import BupSpinner from '@BUP/components/Loading/Spinner'
import { useTranslation } from 'react-i18next'
import { useGetResultsGroupedByYear } from '@BUP/hooks/Sociogram/useGetResultsGroupedByYear'
import AlertComponent from '@BUP/components/Generics/Alert'
import { monitorException } from '@BUP/services/monitor'

export const ResultsGroupedByYearContext = createContext()

export const ResultsGroupedByYearContextProvider = ({ organizationId, children }) => {
  const i18n = useTranslation()

  const { results, isLoadingResults, errorResults, fetchResults } = useGetResultsGroupedByYear(organizationId)

  if (isLoadingResults) {
    return (
      <div className={styles.alert_wrapper}>
        <BupSpinner size='large' />
      </div>
    )
  }

  if (errorResults) {
    const error = new Error(`Error in useGetResultsGroupedByYear request, /results/group-by-year?organizationId=${organizationId}`, { cause: errorResults })
    monitorException(error, { extra: organizationId })

    return (
      <div className={styles.alert_wrapper}>
        <AlertComponent type='error' message={i18n.t('pages.data.historicalSociogram.results.error.text')} />
      </div>
    )
  }

  if (!results || Object.keys(results).length === 0) return null

  return (
    <ResultsGroupedByYearContext.Provider value={{ results, fetchResults }}>
      {children}
    </ResultsGroupedByYearContext.Provider>
  )
}
